import script from "./EditIncome.vue?vue&type=script&setup=true&lang=js"
export * from "./EditIncome.vue?vue&type=script&setup=true&lang=js"

import "./EditIncome.vue?vue&type=style&index=0&id=73d2cda3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d2cda3"]])

export default __exports__